import { useQuery } from '@apollo/client';

import User from 'js/lib/user';

import { useDegreeContext } from 'bundles/degree-home/components/v2/DegreeHomeContext';
import type {
  UseCurriculumQuery as UseCurriculumQueryData,
  UseCurriculumQueryVariables,
} from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/useCurriculum';
import UseCurriculumQuery from 'bundles/degree-home/components/v3-dpm/lib/__queries__/useCurriculum.graphql';

const useCurriculum = () => {
  const { degreeId } = useDegreeContext();

  const variables: UseCurriculumQueryVariables = {
    degreeId,
    userId: `${User.get().id}`,
  };
  const { refetch, ...queryResult } = useQuery<UseCurriculumQueryData, UseCurriculumQueryVariables>(
    UseCurriculumQuery,
    {
      variables,
      context: { clientName: 'gatewayGql' },
    }
  );
  return { refetch, ...queryResult };
};

export default useCurriculum;
